export type VideoTestimonialId =
  | "ali-abdaal"
  | "austeja"
  | "viviana"
  | "russell"
  | "sarah-martin"
  | "brand-montage";

export type VideoTestimonial = {
  id: VideoTestimonialId;
  youtubeId: string;
  youtubeUrl: string;
  embedUrl: string;
  posterSrc: string;
  title: string;
  person: string;
  role: string;
  summary: string;
  contextLabel: string;
};

const VIDEO_TESTIMONIALS: VideoTestimonial[] = [
  {
    id: "ali-abdaal",
    youtubeId: "QCvj6q45Kj4",
    youtubeUrl: "https://youtu.be/QCvj6q45Kj4",
    embedUrl: "https://www.youtube-nocookie.com/embed/QCvj6q45Kj4?rel=0",
    posterSrc: "https://i.ytimg.com/vi/QCvj6q45Kj4/maxresdefault.jpg",
    title: "Ali Abdaal on Singing Attitude",
    person: "Ali Abdaal",
    role: "Creator and entrepreneur",
    summary:
      "A thoughtful account of what it felt like to work with Liuba when clarity, trust, and a high standard of coaching really mattered.",
    contextLabel: "A trusted voice",
  },
  {
    id: "austeja",
    youtubeId: "zgF2KK4l7pc",
    youtubeUrl: "https://youtu.be/zgF2KK4l7pc",
    embedUrl: "https://www.youtube-nocookie.com/embed/zgF2KK4l7pc?rel=0",
    posterSrc: "https://i.ytimg.com/vi/zgF2KK4l7pc/maxresdefault.jpg",
    title: "Austeja on her Singing Attitude experience",
    person: "Austeja",
    role: "Student testimonial",
    summary:
      "A grounded student story for singers who want to hear how the work feels from the inside, not just what changes on paper.",
    contextLabel: "A real student story",
  },
  {
    id: "viviana",
    youtubeId: "V_h8Bedu8oU",
    youtubeUrl: "https://youtu.be/V_h8Bedu8oU",
    embedUrl: "https://www.youtube-nocookie.com/embed/V_h8Bedu8oU?rel=0",
    posterSrc: "https://i.ytimg.com/vi/V_h8Bedu8oU/maxresdefault.jpg",
    title: "Viviana on finding confidence in her voice",
    person: "Viviana",
    role: "Student testimonial",
    summary:
      "A reassuring story for singers who want to feel more confident, less self-conscious, and more at home in the voice.",
    contextLabel: "Confidence returning",
  },
  {
    id: "russell",
    youtubeId: "3PGHrUiQk5Q",
    youtubeUrl: "https://www.youtube.com/watch?v=3PGHrUiQk5Q",
    embedUrl: "https://www.youtube-nocookie.com/embed/3PGHrUiQk5Q?rel=0",
    posterSrc: "https://i.ytimg.com/vi/3PGHrUiQk5Q/maxresdefault.jpg",
    title: "Russell on the change he noticed",
    person: "Russell",
    role: "Student testimonial",
    summary:
      "A clear example of what it can feel like when the right diagnosis starts turning confusion into progress.",
    contextLabel: "Progress made clearer",
  },
  {
    id: "sarah-martin",
    youtubeId: "HdcZTAVOLaE",
    youtubeUrl: "https://youtu.be/HdcZTAVOLaE",
    embedUrl: "https://www.youtube-nocookie.com/embed/HdcZTAVOLaE?rel=0",
    posterSrc: "https://i.ytimg.com/vi/HdcZTAVOLaE/maxresdefault.jpg",
    title: "Sarah Martin on working with Liuba",
    person: "Sarah Martin",
    role: "Founder, She Republic",
    summary:
      "A calm, credible perspective for anyone who wants to know the coaching feels thoughtful, professional, and worth taking seriously.",
    contextLabel: "Professional perspective",
  },
  {
    id: "brand-montage",
    youtubeId: "CB_jj80c9k8",
    youtubeUrl: "https://youtu.be/CB_jj80c9k8",
    embedUrl: "https://www.youtube-nocookie.com/embed/CB_jj80c9k8?rel=0",
    posterSrc: "https://i.ytimg.com/vi/CB_jj80c9k8/maxresdefault.jpg",
    title: "Singing Attitude client montage",
    person: "Multiple clients",
    role: "Brand testimonial reel",
    summary:
      "A broader mix of voices for anyone who wants to hear how different singers describe the experience in their own words.",
    contextLabel: "More client voices",
  },
];

export function getVideoTestimonials(ids?: VideoTestimonialId[]) {
  if (!ids?.length) return VIDEO_TESTIMONIALS;

  const requested = new Set(ids);
  return VIDEO_TESTIMONIALS.filter((item) => requested.has(item.id));
}

export function getVideoTestimonial(id: VideoTestimonialId) {
  return VIDEO_TESTIMONIALS.find((item) => item.id === id) ?? null;
}
